import { SearchInput } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const QueryFilter = ({ onChange, defaultValue, placeholder, onChangeValue, width, disabled }) => {
  const handleChange = value => {
    onChange(value)
  }

  return (
    <Styles.Container width={width}>
      <SearchInput
        fullWidth
        placeholder={placeholder}
        value={defaultValue}
        onSearch={handleChange}
        minCharsToTrigger={4}
        searchTimeout={2000}
        onChangeValue={onChangeValue}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default QueryFilter
